import React from 'react';

const externalSources = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.332764 4.66725C0.332764 2.0895 5.55651 0 12 0C18.4435 0 23.6673 2.0895 23.6673 4.66725V7C23.6673 9.57775 18.4435 11.6672 12 11.6672C5.55651 11.6672 0.332764 9.57775 0.332764 7V4.66725Z"
        fill="white"
      />
      <path
        d="M0.332764 11.0859V16.3359C0.332764 18.9102 5.55651 21.0014 12 21.0014C18.4435 21.0014 23.6673 18.9119 23.6673 16.3342V11.0859C22.8792 11.6537 22.0217 12.1183 21.1158 12.4684C18.6675 13.4484 15.4423 14.0014 12 14.0014C8.55951 14.0014 5.33426 13.4467 2.88601 12.4684C1.98004 12.1183 1.12258 11.6537 0.334514 11.0859H0.332764Z"
        fill="white"
      />
      <path
        d="M23.6673 20.4197C22.8791 20.9868 22.0216 21.4508 21.1158 21.8005C18.6658 22.7805 15.4423 23.3335 11.9983 23.3335C8.55776 23.3335 5.33251 22.7805 2.88426 21.8005C1.97831 21.4503 1.12085 20.9857 0.332764 20.418V23.3335C0.332764 25.9112 5.55651 28.0007 12 28.0007C18.4435 28.0007 23.6673 25.9112 23.6673 23.3335V20.4197Z"
        fill="white"
      />
    </svg>
  );
};

export default externalSources;
